import { render, staticRenderFns } from "./p_invest019.vue?vue&type=template&id=2245d018&scoped=true&"
import script from "./p_invest019.vue?vue&type=script&lang=js&"
export * from "./p_invest019.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245d018",
  null
  
)

export default component.exports